export default "__VITE_ASSET__cae6vr3H__"